import styled from 'styled-components';
import Base from './base';

// reverted background color to #00aed9 because multiple components using different themes are calling this

const BlueButton = styled(Base)`
  background-color: #00aed9;
  font-weight: 450;
`;

export default BlueButton;
